module.exports = __webpack_public_path__ + "static/img/3.2206c68.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/3.jpg
// module id = w63Q
// module chunks = 12